import { openBlock as o, createElementBlock as c, createElementVNode as n, defineComponent as h, computed as _, createBlock as i, resolveDynamicComponent as d, createCommentVNode as f } from "vue";
import { _ as s } from "./chunks/_plugin-vue_export-helper.dad06003.js";
import './assets/index35.css';const v = {
  sm: "12px",
  md: "16px",
  lg: "24px",
  xl: "32px",
  "2xl": "48px"
}, u = {}, p = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, w = /* @__PURE__ */ n("path", {
  fill: "#282828",
  d: "M5 5h14v14H5z"
}, null, -1), m = /* @__PURE__ */ n("path", {
  d: "M12 1.44a10.56 10.56 0 1 0 0 21.12 10.56 10.56 0 0 0 0-21.12Zm5.09 14.294a.479.479 0 0 1 0 .68l-.679.679a.48.48 0 0 1-.677 0L12 13.358l-3.734 3.735a.48.48 0 0 1-.677 0l-.68-.68a.48.48 0 0 1 0-.679L10.643 12 6.91 8.268a.48.48 0 0 1 0-.68l.679-.678a.48.48 0 0 1 .677 0L12 10.644l3.734-3.734a.48.48 0 0 1 .677 0l.68.679a.478.478 0 0 1 0 .679L13.357 12l3.732 3.734Z",
  fill: "var(--red20)"
}, null, -1), $ = [
  w,
  m
];
function x(e, t) {
  return o(), c("svg", p, $);
}
const g = /* @__PURE__ */ s(u, [["render", x]]), M = {}, Z = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, I = /* @__PURE__ */ n("path", {
  fill: "#fff",
  d: "M10 10h28v28H10z"
}, null, -1), k = /* @__PURE__ */ n("path", {
  fill: "var(--red50)",
  d: "M23.9999 2.88A21.1203 21.1203 0 0 0 4.4876 15.9177 21.12 21.12 0 1 0 23.9999 2.88Zm10.1808 28.5888a.9591.9591 0 0 1 .2815.6792.9597.9597 0 0 1-.2815.6792l-1.3584 1.3584a.9601.9601 0 0 1-1.3536 0l-7.4688-7.4688-7.4688 7.4688a.9601.9601 0 0 1-1.3536 0l-1.3584-1.3584a.9591.9591 0 0 1-.2816-.6792.9598.9598 0 0 1 .2816-.6792L21.2831 24l-7.464-7.464a.9591.9591 0 0 1-.2816-.6792.9598.9598 0 0 1 .2816-.6792l1.3584-1.3584a.9601.9601 0 0 1 1.3536 0l7.4688 7.4688 7.4688-7.4688a.9601.9601 0 0 1 1.3536 0l1.3584 1.3584a.9591.9591 0 0 1 .2815.6792.9597.9597 0 0 1-.2815.6792L26.7167 24l7.464 7.4688Z"
}, null, -1), B = [
  I,
  k
];
function z(e, t) {
  return o(), c("svg", Z, B);
}
const b = /* @__PURE__ */ s(M, [["render", z]]), H = {}, L = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, y = /* @__PURE__ */ n("path", {
  fill: "#282828",
  d: "M5 5h14v14H5z"
}, null, -1), V = /* @__PURE__ */ n("path", {
  d: "M12 1.44a10.56 10.56 0 1 0 0 21.12 10.56 10.56 0 0 0 0-21.12Zm-.96 5.26a.48.48 0 0 1 .48-.48h.96a.48.48 0 0 1 .48.48v.96a.48.48 0 0 1-.48.48h-.96a.48.48 0 0 1-.48-.48V6.7Zm2.88 10.6a.48.48 0 0 1-.48.48h-2.88a.48.48 0 0 1-.48-.48v-.96a.48.48 0 0 1 .48-.48h.48v-3.84h-.48a.48.48 0 0 1-.48-.48v-.96a.48.48 0 0 1 .48-.48h1.92a.48.48 0 0 1 .48.48v5.28h.48a.48.48 0 0 1 .48.48v.96Z",
  fill: "var(--blue20)"
}, null, -1), W = [
  y,
  V
];
function E(e, t) {
  return o(), c("svg", L, W);
}
const C = /* @__PURE__ */ s(H, [["render", E]]), F = {}, S = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, A = /* @__PURE__ */ n("path", {
  fill: "#fff",
  d: "M10 10h28v28H10z"
}, null, -1), N = /* @__PURE__ */ n("path", {
  fill: "var(--blue50)",
  d: "M24 2.88a21.12 21.12 0 1 0 0 42.24 21.12 21.12 0 0 0 0-42.24ZM22.08 13.4a.96.96 0 0 1 .96-.96h1.92a.96.96 0 0 1 .96.96v1.92a.96.96 0 0 1-.96.96h-1.92a.96.96 0 0 1-.96-.96V13.4Zm5.76 21.2a.96.96 0 0 1-.96.97h-5.76a.96.96 0 0 1-.96-.96v-1.92a.96.96 0 0 1 .96-.96h.96v-7.68h-.96a.96.96 0 0 1-.96-.96v-1.92a.96.96 0 0 1 .96-.96h3.84a.96.96 0 0 1 .96.96v10.56h.96a.96.96 0 0 1 .96.96v1.92Z"
}, null, -1), P = [
  A,
  N
];
function D(e, t) {
  return o(), c("svg", S, P);
}
const j = /* @__PURE__ */ s(F, [["render", D]]), q = {}, G = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, J = /* @__PURE__ */ n("path", {
  fill: "#282828",
  d: "M10 10h28v28H10z"
}, null, -1), K = /* @__PURE__ */ n("path", {
  fill: "var(--green50)",
  d: "M24 2.88a21.12 21.12 0 1 0 0 42.24 21.12 21.12 0 0 0 0-42.24ZM36.2 18.4 20.84 33.76a.96.96 0 0 1-1.36 0l-7.68-7.68a.96.96 0 0 1 0-1.36l1.36-1.35a.96.96 0 0 1 1.36 0l5.64 5.64L33.48 15.7a.96.96 0 0 1 1.36 0l1.36 1.35a.96.96 0 0 1 0 1.36Z"
}, null, -1), O = [
  J,
  K
];
function Q(e, t) {
  return o(), c("svg", G, O);
}
const R = /* @__PURE__ */ s(q, [["render", Q]]), T = {}, U = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, X = /* @__PURE__ */ n("path", {
  fill: "#282828",
  d: "M12 10h24v28H12z"
}, null, -1), Y = /* @__PURE__ */ n("path", {
  fill: "var(--orange50)",
  d: "M24 2.88a21.12 21.12 0 1 0 0 42.24 21.12 21.12 0 0 0 0-42.24Zm1.92 31.73a.96.96 0 0 1-.96.96h-1.92a.96.96 0 0 1-.96-.96v-1.92a.96.96 0 0 1 .96-.96h1.92a.96.96 0 0 1 .96.96v1.92Zm0-7.68a.96.96 0 0 1-.96.96h-1.92a.96.96 0 0 1-.96-.96V13.49a.96.96 0 0 1 .96-.96h1.92a.96.96 0 0 1 .96.96v13.44Z"
}, null, -1), n0 = [
  X,
  Y
];
function t0(e, t) {
  return o(), c("svg", U, n0);
}
const e0 = /* @__PURE__ */ s(T, [["render", t0]]), o0 = {}, c0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, s0 = /* @__PURE__ */ n("path", {
  fill: "#fff",
  d: "M10 10h28v28H10z"
}, null, -1), a0 = /* @__PURE__ */ n("path", {
  fill: "var(--green50)",
  d: "M24 2.88a21.12 21.12 0 1 0 0 42.24 21.12 21.12 0 0 0 0-42.24ZM36.2 18.4 20.84 33.76a.96.96 0 0 1-1.36 0l-7.68-7.68a.96.96 0 0 1 0-1.36l1.36-1.35a.96.96 0 0 1 1.36 0l5.64 5.64L33.48 15.7a.96.96 0 0 1 1.36 0l1.36 1.35a.96.96 0 0 1 0 1.36Z"
}, null, -1), _0 = [
  s0,
  a0
];
function l0(e, t) {
  return o(), c("svg", c0, _0);
}
const r0 = /* @__PURE__ */ s(o0, [["render", l0]]), h0 = {}, i0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, d0 = /* @__PURE__ */ n("path", {
  fill: "#fff",
  d: "M12 10h24v28H12z"
}, null, -1), f0 = /* @__PURE__ */ n("path", {
  fill: "var(--orange50)",
  d: "M24 2.88a21.12 21.12 0 1 0 0 42.24 21.12 21.12 0 0 0 0-42.24Zm1.92 31.73a.96.96 0 0 1-.96.96h-1.92a.96.96 0 0 1-.96-.96v-1.92a.96.96 0 0 1 .96-.96h1.92a.96.96 0 0 1 .96.96v1.92Zm0-7.68a.96.96 0 0 1-.96.96h-1.92a.96.96 0 0 1-.96-.96V13.49a.96.96 0 0 1 .96-.96h1.92a.96.96 0 0 1 .96.96v13.44Z"
}, null, -1), v0 = [
  d0,
  f0
];
function u0(e, t) {
  return o(), c("svg", i0, v0);
}
const p0 = /* @__PURE__ */ s(h0, [["render", u0]]), g0 = /* @__PURE__ */ h({
  __name: "FeedbackIcon",
  props: {
    type: {},
    size: { default: "md" },
    color: { default: "black" }
  },
  setup(e) {
    const t = e, l = {
      black: {
        error: g,
        info: C,
        success: R,
        warning: e0
      },
      white: {
        error: b,
        info: j,
        success: r0,
        warning: p0
      }
    }, r = _(() => v[t.size]), a = _(() => l[t.color][t.type]);
    return (w0, m0) => a.value ? (o(), i(d(a.value), {
      key: 0,
      width: r.value,
      class: "FeedbackIcon"
    }, null, 8, ["width"])) : f("", !0);
  }
});
export {
  g0 as FeedbackIcon
};
